import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DoneIcon from '@mui/icons-material/Done';
import { Popover as MUIPopover, Stack, TextField, Tooltip, IconButton, Typography } from '@mui/material';

type PopoverProps = {
  id: string | undefined;
  open: boolean;
  anchorEl: HTMLElement | null;
  handleClose: () => void;
  isCopied: boolean;
  setIsCopied: (copied: boolean) => void;
  selectedEvent: { id: number } | null;
  handleCloseSharePopover: () => void;
  setNotificationMessage: (message: {
    messageTitle: string;
    messageBody: string;
    intent: 'success' | 'error' | 'info' | 'warning';
  }) => void;
};

export const Popover = ({
  id,
  open,
  anchorEl,
  handleClose,
  isCopied,
  setIsCopied,
  selectedEvent,
  handleCloseSharePopover,
  setNotificationMessage,
}: PopoverProps) => {
  const eventLink = selectedEvent?.id ? `${globalThis.location.origin}/event/${selectedEvent.id}` : '';

  const handleCopyToClipboard = async () => {
    if (!eventLink) {
      return;
    }

    try {
      await navigator.clipboard.writeText(eventLink);
      setIsCopied(true);
      handleCloseSharePopover();
    } catch (err) {
      console.error('Failed to copy link: ', err);
      setNotificationMessage({
        messageTitle: 'Copy Failed',
        messageBody: 'Could not copy the link to your clipboard.',
        intent: 'error',
      });
      setIsCopied(false);
    }
  };

  const handleCopyClick = () => {
    void handleCopyToClipboard();
  };

  return (
    <MUIPopover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      <Stack direction="row" spacing={1} sx={{ p: 2, alignItems: 'center', width: '400px' }}>
        <TextField
          value={eventLink}
          variant="outlined"
          size="small"
          slotProps={{
            input: {
              readOnly: true,
            },
          }}
          sx={{ flexGrow: 1, minWidth: 'max-content' }}
        />
        <Tooltip
          title={
            <Typography variant="caption" gutterBottom sx={{ m: 0, display: 'block' }}>
              {isCopied ? 'Copied!' : 'Copy to clipboard'}
            </Typography>
          }
          arrow
          placement="top"
        >
          <IconButton onClick={handleCopyClick} size="small">
            {isCopied ? <DoneIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
          </IconButton>
        </Tooltip>
      </Stack>
    </MUIPopover>
  );
};
